/**
 * Created by Administrator on 2017/4/24.
 */
import "./layer.js"

var dialog = {
    //提示层
    msg(msg,style,time){
        let _style = 'background-color:#000;color:#fff;opacity:.9;width:40%'
        let _time = 2
        if(style != null){
            _style = style
        }
        if(time != null){
            _time = time
        }
        layer.open({
            content:msg,
            style:_style,
            time: _time,
        });
    },
    //提示层需要跳转链接
    msgEnd(msg,url,style,time){
        let _style = 'background-color:#000;color:#fff;opacity:.9;width:40%'
        let _time = 2
        if(style != null){
            _style = style
        }
        if(time != null){
            _time = time
        }
        layer.open({
            content:msg,
            style:_style,
            time: _time,
            end:function(){
                location.href = url
            }
        });
    },
    //显示加载层
    loading(msg,type){
        let _type = 2
        if(type != null){
            _type = type
        }
        layer.open({
            type: _type,
            content: msg,
            shadeClose:false,
        });
    },
    //关闭加载层
    closeLoading(){
        let index = $(".layui-m-layer2").attr("index")
        layer.close(index);
    }
}

window.dialog = dialog;
export default dialog;



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/common/dialog.js
 **/